module.exports = __webpack_public_path__ + "img/04.50dac1e3.jpg";